import { deviceDetect } from "mobile-device-detect";

export function getDeviceType() {
  const { isMobile, isTablet } = deviceDetect();

  if (isMobile) {
    return "Mobile";
  } else if (isTablet) {
    return "Tablet";
  } else {
    return "Desktop";
  }
}
